/*
 * @Author: Vanny
 * @Date: 2019-11-18 19:12:06
 * @LastEditors: Vanny
 * @LastEditTime: 2020-05-18 10:44:12
 * @Description:
 */
import { combineReducers } from 'redux';
import { all, takeEvery, select } from 'redux-saga/effects';
import { connectRouter } from 'connected-react-router';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import * as Sentry from '@sentry/browser';
import * as app from './app';

const modules = { app };
const models = require.context('./module', false, /\.js$/);
models.keys().forEach((key) => {
  const k = key.replace(/(.*\/)*([^.]+).*/gi, '$2');
  modules[k] = models(key);
});

export const effects = Object.keys(modules).reduce((efs, mEffectsName) => {
  const mEffects = modules[mEffectsName].effects;
  efs = Object.keys(mEffects).reduce((efs, efKey) => {
    const e = mEffects[efKey];
    efs[`${mEffectsName}/${efKey}`] = e;
    return efs;
  }, efs);
  return efs;
}, {});

function handleActions(handlers, initialState, namespace) {
  const reducers = Object.keys(handlers).map((type) => {
    return (state, action) => {
      if (action.type === `${namespace}/${type}`) {
        return handlers[type](state, action);
      }
      return state;
    };
  });
  const reducer = (state, action) =>
    reducers.reduce((s, r) => {
      return r(s, action);
    }, state);
  return (state = initialState, action) => {
    if (action.type === `${namespace}/setState`) {
      return { ...state, ...action.payload };
    }
    return reducer(state, action);
  };
}

export function getReducers(history) {
  const mReducers = Object.keys(modules).reduce((rds, namespace) => {
    const m = modules[namespace];
    rds[namespace + 'State'] = handleActions(m.reducers || {}, m.state, namespace);
    return rds;
  }, {});
  return combineReducers({
    router: connectRouter(history),
    ...mReducers,
    appState: persistReducer({ key: 'app', storage }, mReducers.appState),
  });
}

function* saga() {
  yield all(
    Object.keys(effects).map((key) =>
      takeEvery(key, function*(action) {
        try {
          if (effects[action.type]) {
            const ret = yield effects[action.type](action);
            action._resolve && action._resolve(ret);
          }
        } catch (err) {
          action._reject && action._reject(err);
          const { appState } = yield select();
          Sentry.withScope((scope) => {
            scope.addBreadcrumb({
              category: 'redux',
              type: action.type,
            });
            scope.setExtra('action', action);
            scope.setExtra('userInfo', appState.userInfo);
            scope.setExtra('token', appState.token);
            scope.setExtra('maskToken', appState.maskToken);
            Sentry.captureException(err);
          });
        }
      })
    )
  );
}

export default saga;
